module.exports = __webpack_public_path__ + "img/1.854a6d0d.png";